<template>
  <div>
    <div class="weixin-tip">
      <p>
        <img src="/static/img/live_weixin.png" alt="微信打开"/>
      </p>
	</div>
    <div class="zs-wmain">
      <div class="html zhengshu-result2">
        <div class="head">
          <span class="column">查询结果</span>
          <span class="backhome"
            ><router-link to="/">返回主页</router-link></span
          >
          <span class="query"
            ><router-link :to="global.isPhone()?`/inqCertM?type=${certtype}`:`/inqCert?type=${certtype}`">继续查询</router-link></span
          >
        </div>
        <div class="table-head">
          <span class="baseinfo">基本信息</span
          ><br/><span class="en">Essential information</span>
        </div>
        <div class="wtable" >
          <table v-if="inqsucess" border="0" cellspacing="0" cellpadding="0" class="table-data">
            <tbody>
              <tr>
                <td>姓名</td>
                <td>{{ cert.name }}</td>
                <td>性别</td>
                <td>{{ cert.sex }}</td>
              </tr>
              <tr>
                <td>身份证号</td>
                <td>{{ cert.cardid }}</td>
                <td>编号</td>
                <td>{{ cert.certid }}</td>
              </tr>
              <tr>
                <td>岗位名称</td>
                <td>{{ cert.certifyname }}</td>
                <td>发证时间</td>
                <td>{{ cert.certifydate }}</td>
              </tr>
               <tr>
                <td>工作单位</td>
                <td  colspan="3">{{ cert.company}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-head"  v-if="inqsucess">
          <span class="baseinfo">查询信息</span
          ><br/><span class="en">Certificate information</span>
        </div>
        <div class="wtable ztable" style="text-align: center;    overflow: hidden;"  v-if="inqsucess&&certtype!='zydj'">
 <div >
                      <div class="demo-image__preview" style="    width: 80%;
    
    margin: auto;">
                          <el-image
                            :src="`${global.remoteIp}/uploads/证书图下载/${
                             cert.isnewcertpic?cert.certid+'_'+cert.cardid:cert.certid
                            }.jpg`"
                            :preview-src-list="[
                              `${global.remoteIp}/uploads//证书图下载/${
                                cert.isnewcertpic?cert.certid+'_'+cert.cardid:cert.certid
                            }.jpg?t=${Math.random()}`,
                            ]"
                          >
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"></i>
                            </div>
                          </el-image>
                        </div>
                  </div>
                  <span @click="download()">点击下载</span>
         
        </div>
        <div class="wtable"  v-if="inqsucess&&certtype=='zydj'">
          <table v-if="inqsucess" border="0" cellspacing="0" cellpadding="0" class="table-data">
            <tbody>
              <tr>
                <td>编号</td>
                <td style="width:85%">{{ cert.certid }}</td>
              </tr>
              <tr>
                <td>职业名称</td>
                <td style="width:85%">{{ cert.certifyname }}</td>
              </tr>
              <tr>
                <td>等级</td>
                <td style="width:85%">{{ cert.certifylevel }}</td>
              </tr>
              <tr>
                <td>考核成绩</td>
                <td  style="width:85%">{{ cert.studycourse}}</td>
              </tr>
               <tr>
                <td>发证日期</td>
                <td  style="width:85%">{{ cert.certifydate}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import HeadNav from "../components/PublicComs/HeadNav";
import FootInfo from "../components/HomeComs/FootInfo.vue";
import global from "@/components/PublicComs/Common.vue";
import { Message} from "element-ui"
export default {
  metaInfo: {
      title: '信息查询',
       meta: [
        { name:'viewport', content:
        `width=device-width, user-scalable=no, initial-scale=${1}, maximum-scale=${1}, minimum-scale=${1}`}
      ]
    },
  props: {},
  components: { FootInfo, HeadNav },
  data() {
    return {
      global,
      cert: {},
      result: false,
      restext: "请输入查询条件",
      plates: [],
      webConfigs: {},
      type: "",
      queryType: "人才信息",
      cardid: "",
      certid: "",
      companyname: "",
      socialcreditcode: "",
      id:'',
      inqsucess:false,
      querypath:global.isPhone()?'/inqCertM':'/inqCert',
      certtype:''
    };
  },

  created() {
    let code = this.$route.query.code;
    let name = this.$route.query.name;
    this.certtype = this.$route.query.certtype
    
  },

  methods: {
    download() {
      if(this.global.isPhone()&&this.isWeixinBrowser())
      {
        var winHeight = $(window).height();
        $(".weixin-tip").css("height",winHeight);
        $(".weixin-tip").show();
        return;
      }
      // window.open(`${global.remoteIp}/uploads/证书图下载/${this.cert.code}.jpg`, "_blank");
      // return;
      this.$axios
        .get(`${global.remoteIp}/uploads/证书图下载/${this.cert.isnewcertpic?this.cert.certid+'_'+this.cert.cardid:this.cert.certid}.jpg`, {
          responseType: "blob", //重要
        })
        .then((response) => {
          if ("msSaveOrOpenBlob" in window.navigator) {
            //兼容ie浏览器下载报传递给系统调用的数据区域太小.
            var data = response.data;
            var blob = new Blob([data], { type: "application/vnd.ms-excel" });
            window.navigator.msSaveOrOpenBlob(blob, `${this.cert.isnewcertpic?this.cert.certid+'_'+this.cert.cardid:this.cert.certid}.jpg`);
            return;
          } else {
            const u = navigator.userAgent;
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isiOS&&!this.isWeixinBrowser()) {
              var jpeg = new Blob([response.data], { type: "image/jpeg" });
              const url = window.URL.createObjectURL(jpeg);
              const link = document.createElement("a");
              let fname = `${this.cert.isnewcertpic?this.cert.certid+'_'+this.cert.cardid:this.cert.certid}.jpg`;
              link.href = url;
              link.setAttribute("download", fname);
              link.download = fname;
              document.body.appendChild(link);
              link.click();
              return;
            }
            else if(isiOS&&this.isWeixinBrowser())
            {
              var winHeight = $(window).height();
              $(".weixin-tip").css("height",winHeight);
              $(".weixin-tip").show();
              return;
            }
            window.open(
              `${global.remoteIp}/api/loadimg?imgpath=证书图下载/${
                this.cert.isnewcertpic?this.cert.certid+'_'+this.cert.cardid:this.cert.certid
              }.jpg`,
              "_blank"
            );
          }
        });
    },
    isWeixinBrowser() {
      return /micromessenger/.test(navigator.userAgent.toLowerCase())
        ? true
        : false;
    },
    isQQBrowser() {
      return /qq/.test(navigator.userAgent.toLowerCase()) ? true : false;
    },
  },

  computed: {},

  mounted() {
     let code = this.$route.query.code;
    let name = this.$route.query.name;
    let url = `/api/certificates1/userget?certid=${code}&name=${name}`
    if(this.certtype =='zydj')
    {
      url = `/api/certificates2/userget?certid=${code}&name=${name}`
    }
    this.$axios
      .get(encodeURI(url))
      .then((res) => {
        if (res.data.data.length > 0) {
          this.cert = res.data.data[0];
          let certtime = this.cert.certifydate;
          if(certtime.indexOf(".")>-1)
          {
            let arrtime = certtime.split(".");
            this.cert.certifydate = arrtime[0]+'年'+arrtime[1]+"月"+arrtime[2]+"日"
          }
          
          this.inqsucess = true;
          return;
        } else {
          this.$router.replace(this.querypath+'?type='+this.certtype);
          Message.error("为查询到任何信息，请重新输入信息查询！");
        }
      })
      .catch((err) => {
        this.$router.replace(this.querypath+'?type='+this.certtype);
        Message.error("为查询到任何信息，请重新输入信息查询！");
      });
    
  },

  watch: {},
};
</script>
<style scoped>
.zhengshu-result2 .ztable .table-data tr td:nth-child(1)
{ 
  width: 9%;
}
.zs-wmain {
  padding: 100px 0;
  background-color: #ebebeb;
  background-position: center top;
  background-size: contain;
}
.zs-main.zhengshu {
  border: 1px solid #f0f0f0;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 5px;
  width: 760px;
  margin: 0 auto;
  padding: 50px 0;
}
.zs-main.zhengshu table tr td {
  padding: 13px;
  white-space: nowrap;
}
.zs-main.zhengshu .zhengshu-form-add .head {
  text-align: center;
}
.zs-main.zhengshu .zhengshu-form-add .head .c {
  font-size: 20px;
  color: #1b57af;
}
.zs-main.zhengshu .zhengshu-form-add .head .c2 {
  display: inline-block;
  margin: 0 15px;
}
.zs-main.zhengshu .zhengshu-form-add .head .c3 {
  font-size: 14px;
  color: #f01100;
}
.zs-main.zhengshu .zhengshu-form-add .head .c3 a {
  color: #f01100;
}
.zs-main.zhengshu .zhengshu-form-add .list {
  width: 340px;
  margin: 40px auto 0;
}
.zs-main.zhengshu .zhengshu-form-add .list dl {
  padding-left: 95px;
  margin-top: 10px;
  height: 35px;
}
.zs-main.zhengshu .zhengshu-form-add .list dl dt {
  float: left;
  margin-left: -95px;
  line-height: 30px;
  font-size: 14px;
}
.zs-main.zhengshu .zhengshu-form-add .list dl dd .input {
  width: 100%;
  height: 35px;
  border: 1px solid #e6e6e6;
  outline: 0px;
  box-sizing: border-box;
  padding: 0 10px;
}
.zs-main.zhengshu .zhengshu-form-add .list dl.btn {
  text-align: center;
}
.zs-main.zhengshu .zhengshu-form-add .list dl.btn dd {
  margin-top: 35px;
}
.zs-main.zhengshu .zhengshu-form-add .list dl.btn dd .zhengshu-btn {
  background-color: #ea3430;
  border: 0px;
  width: 150px;
  height: 40px;
  color: #fff;
  outline: 0px;
  cursor: pointer;
  font-size: 20px;
  background-image: url(/static/img/zhengshu-button.png);
  background-repeat: no-repeat;
  background-position: 20px center;
  text-align: right;
  padding: 0 10px;
  border-radius: 3px;
}

.zs-main.zhengshu .zhengshu-result table tr td {
  padding: 10px;
  white-space: nowrap;
}

.zhengshu-result2,
.zhengshu-norecord {
  border: 1px solid #f0f0f0;
  background-color: #fff;
  border-radius: 5px;
  width: 1200px;
  margin: 0 auto;
  padding: 15px;
  box-sizing: border-box;
}
.zhengshu-result2 .head {
  height: 44px;
  border-bottom: 1px solid #e7e7e7;
}
.zhengshu-result2 .head .column {
  float: left;
  line-height: 44px;
  font-size: 18px;
      font-weight: 600;
    color: #1b57af;
}
.zhengshu-result2 .head .query {
  float: right;
  padding-left: 20px;
  background-image: url(/static/img/zhengshu-result-query.gif);
  background-repeat: no-repeat;
  background-position: left center;
  font-size: 14px;
  margin-top: 10px;
  margin-right: 10px;
}
.zhengshu-result2 .head .backhome {
  float: right;
  padding-left: 20px;
  background-image: url(/static/img/zhengshu-result-backhome.gif);
  background-repeat: no-repeat;
  background-position: left center;
  font-size: 14px;
  margin-top: 10px;
}

.zhengshu-result2 .head3 {
  padding: 20px 0;
  padding-left: 220px;
  border-bottom: 5px solid #ddd;
}
.zhengshu-result2 .head3 .pic {
  float: left;
  margin-left: -220px;
  width: 200px;
}
.zhengshu-result2 .head3 .pic img {
  width: 100%;
  height: 220px;
}
.zhengshu-result2 .head3 .title {
  font-size: 25px;
  margin-bottom: 20px;
}
.zhengshu-result2 .head3 .title2 {
  margin-bottom: 10px;
}
.zhengshu-result2 .head2 {
  padding: 20px 0;
  text-align: center;
}
.zhengshu-result2 .head2 ul li {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  color: #fff;
  width: 180px;
  background-color: #1b57af;
  margin: 10px;
  cursor: pointer;
  border-radius: 3px;
}
.zhengshu-result2 .head2 ul li.selected {
  background-color: #e64b47;
}
.zhengshu-result2 .list2 {
  display: none;
}
.zhengshu-result2 .list2.show {
  display: block;
}

.zhengshu-result2 .table-head {
  height: 48px;
  line-height: 19px;
  font-size: 14px;
  color: #fff;
  padding-left: 10px;
  background-color: #1b57af;
  border-radius: 5px 5px 0 0;
  margin-top: 20px;
      padding-top: 10px
}
.zhengshu-result2 .table-head .baseinfo {
  float: left;
  margin-right: 10px;
}
.zhengshu-result2 .table-data {
  border-spacing: 1px;
  border-collapse: separate;
  background-color: #c2e4ff;
  width: 100%;
}
.zhengshu-result2 .table-data td {
  background-color: #fff;
  padding: 10px;
  white-space: nowrap;
}
.zhengshu-result2 .table-data tr td:nth-child(1),
.zhengshu-result2 .table-data tr td:nth-child(3) {
  text-align: right;
  width: 15%;
  font-weight: bold;
  font-size: 16px;
}
.zhengshu-result2 .table-data tr td:nth-child(2),
.zhengshu-result2 .table-data tr td:nth-child(4) {
  width: 35%;
  font-size: 14px;
  color: #999;
}
.zhengshu-result2 .table-data tr td .star:before,
.zhengshu-result2 .table-data tr td .star:after {
  content: "***";
  color: red;
}
.zhengshu-result2 .table-data2 {
  border-spacing: 1px;
  border-collapse: separate;
  background-color: #c2e4ff;
  width: 100%;
}
.zhengshu-result2 .table-data2 td {
  background-color: #fff;
  padding: 10px;
  white-space: nowrap;
}
.zhengshu-result2 .table-data2 tr td:nth-child(1) {
  text-align: right;
  width: 15%;
  font-weight: bold;
  font-size: 16px;
}
.zhengshu-result2 .table-data2 tr td:nth-child(2) {
  width: 35%;
  font-size: 14px;
  color: #999;
}
.zhengshu-result2 .table-data2 tr td dl.zhengshu-qr dt {
  float: left;
}
.zhengshu-result2 .table-data2 tr td dl.zhengshu-qr dd {
  padding-top: 50px;
}
.zhengshu-result2 .table-data2 tr td dl.zhengshu-qr dd .c {
  font-weight: bold;
}
.zhengshu-norecord {
  width: 700px;
  padding: 50px;
}
.zhengshu-norecord ul li {
  line-height: 30px;
}
.zhengshu-norecord ul li.c {
  font-size: 16px;
  font-weight: bold;
  line-height: 30px;
}
.zhengshu-norecord ul li a {
  color: red;
}
.zs-menu {
  float: left;
}
.zs-menu ul li {
  line-height: 30px;
  background-color: #e49a1f;
  border-radius: 3px;
  margin-bottom: 10px;
  padding: 5px 10px;
  text-align: center;
  color: #fff;
  cursor: pointer;
}
.zs-menu ul li a {
  color: #fff;
}
.zs-menu ul li.selected {
  background-color: #ff0000;
}

.zhengshu-result2 .table-data3 {
  border-spacing: 1px;
  border-collapse: separate;
  background-color: #c2e4ff;
  width: 100%;
}
.zhengshu-result2 .table-data3 td {
  background-color: #fff;
  padding: 10px;
}
.zhengshu-result2 .table-data3 td.b {
  font-weight: bold;
}

.zhengshu-result2 .table-data3 tr td .star:before,
.zhengshu-result2 .table-data3 tr td .star:after {
  content: "***";
  color: red;
}
.wtable {
  width: 100%;
  overflow: auto;
}

@media (max-width: 640px) {
  body {
    padding: 0 5px;
  }
  .html {
    width: 100% !important;
  }
  .zs-wmain {
    padding: 10px 0;
  }
  .zs-main.zhengshu {
    width: 96%;
    padding: 50px 0;
  }
  .zs-main.zhengshu .zhengshu-form-add .list dl dd .input {
    width: 96%;
  }
  .zs-main.zhengshu .zhengshu-form-add .list dl dt {
    width: 75px;
    text-align: center;
  }
  .zhengshu-result2 .table-data tr td:nth-child(1),
  .zhengshu-result2 .table-data tr td:nth-child(3) {
    font-weight: normal;
    font-size: 12px;
  }

  .zs-top {
    height: 50px;
    background-size: contain;
    background-position: left center;
  }
  .zs-menu {
    float: none;
    margin-left: 0px;
  }
  .zs-menu ul li {
    margin: 10px 10px;
  }
  .zs-menu ul li a {
    color: #fff;
  }
  .zhengshu-result2 .table-data2 tr td:nth-child(1) {
    font-weight: normal;
    font-size: 12px;
  }
}
.toast-title {
  font-weight: 700;
}
.toast-message {
  -ms-word-wrap: break-word;
  word-wrap: break-word;
}
.toast-message a,
.toast-message label {
  color: #fff;
}
.toast-message a:hover {
  color: #ccc;
  text-decoration: none;
}
.toast-close-button {
  position: relative;
  right: -0.3em;
  top: -0.3em;
  float: right;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  -webkit-text-shadow: 0 1px 0 #fff;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.8;
  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=80);
  filter: alpha(opacity=80);
  line-height: 1;
}
.toast-close-button:focus,
.toast-close-button:hover {
  color: #000;
  text-decoration: none;
  cursor: pointer;
  opacity: 0.4;
  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=40);
  filter: alpha(opacity=40);
}
.rtl .toast-close-button {
  left: -0.3em;
  float: left;
  right: 0.3em;
}
button.toast-close-button {
  padding: 0;
  cursor: pointer;
  background: 0 0;
  border: 0;
  -webkit-appearance: none;
}
.toast-top-center {
  top: 0;
  right: 0;
  width: 100%;
}
.toast-bottom-center {
  bottom: 0;
  right: 0;
  width: 100%;
}
.toast-top-full-width {
  top: 0;
  right: 0;
  width: 100%;
}
.toast-bottom-full-width {
  bottom: 0;
  right: 0;
  width: 100%;
}
.toast-top-left {
  top: 12px;
  left: 12px;
}
.toast-top-right {
  top: 12px;
  right: 12px;
}
.toast-bottom-right {
  right: 12px;
  bottom: 12px;
}
.toast-bottom-left {
  bottom: 12px;
  left: 12px;
}
#toast-container {
  position: fixed;
  z-index: 999999;
  pointer-events: none;
}
#toast-container * {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
#toast-container > div {
  position: relative;
  pointer-events: auto;
  overflow: hidden;
  margin: 0 0 6px;
  padding: 15px 15px 15px 50px;
  width: 300px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  background-position: 15px center;
  background-repeat: no-repeat;
  -moz-box-shadow: 0 0 12px #999;
  -webkit-box-shadow: 0 0 12px #999;
  box-shadow: 0 0 12px #999;
  color: #fff;
  opacity: 0.8;
  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=80);
  filter: alpha(opacity=80);
}
#toast-container > div.rtl {
  direction: rtl;
  padding: 15px 50px 15px 15px;
  background-position: right 15px center;
}
#toast-container > div:hover {
  -moz-box-shadow: 0 0 12px #000;
  -webkit-box-shadow: 0 0 12px #000;
  box-shadow: 0 0 12px #000;
  opacity: 1;
  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
  filter: alpha(opacity=100);
  cursor: pointer;
}
#toast-container > .toast-info {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=) !important;
}
#toast-container > .toast-error {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=) !important;
}
#toast-container > .toast-success {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==) !important;
}
#toast-container > .toast-warning {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=) !important;
}
#toast-container.toast-bottom-center > div,
#toast-container.toast-top-center > div {
  width: 300px;
  margin-left: auto;
  margin-right: auto;
}
#toast-container.toast-bottom-full-width > div,
#toast-container.toast-top-full-width > div {
  width: 96%;
  margin-left: auto;
  margin-right: auto;
}
.toast {
  background-color: #030303;
}
.toast-success {
  background-color: #51a351;
}
.toast-error {
  background-color: #bd362f;
}
.toast-info {
  background-color: #2f96b4;
}
.toast-warning {
  background-color: #f89406;
}
.toast-progress {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 4px;
  background-color: #000;
  opacity: 0.4;
  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=40);
  filter: alpha(opacity=40);
}
@media all and (max-width: 240px) {
  #toast-container > div {
    padding: 8px 8px 8px 50px;
    width: 11em;
  }
  #toast-container > div.rtl {
    padding: 8px 50px 8px 8px;
  }
  #toast-container .toast-close-button {
    right: -0.2em;
    top: -0.2em;
  }
  #toast-container .rtl .toast-close-button {
    left: -0.2em;
    right: 0.2em;
  }
}
@media all and (min-width: 241px) and (max-width: 480px) {
  #toast-container > div {
    padding: 8px 8px 8px 50px;
    width: 18em;
  }
  #toast-container > div.rtl {
    padding: 8px 50px 8px 8px;
  }
  #toast-container .toast-close-button {
    right: -0.2em;
    top: -0.2em;
  }
  #toast-container .rtl .toast-close-button {
    left: -0.2em;
    right: 0.2em;
  }
}
@media all and (min-width: 481px) and (max-width: 768px) {
  #toast-container > div {
    padding: 15px 15px 15px 50px;
    width: 25em;
  }
  #toast-container > div.rtl {
    padding: 15px 50px 15px 15px;
  }
}

.flex {
  display: flex;
}
.keep-flex {
  display: flex;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-x-right {
  justify-content: flex-end;
}
.flex-x-between {
  justify-content: space-between;
}
.flex-x-around {
  justify-content: space-around;
}
.flex-x-center {
  justify-content: center;
}
.flex-y-center {
  align-items: center;
}
.flex-y-right {
  align-items: flex-end;
}
.flex-grow {
  flex-grow: 1;
}
.flex-shrink {
  flex-shrink: 0;
}
.flex-align-center {
  align-self: center;
}

a:link {
  color: #3f3f3f;
  text-decoration: none;
}
a:visited {
  text-decoration: none;
  color: #3f3f3f;
}
a:hover {
  text-decoration: none;
  color: #ff6501;
}
a:active {
  text-decoration: none;
  color: #3f3f3f;
}
.icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  stroke-width: 0;
  stroke: currentColor;
  fill: currentColor;
}
.hide {
  display: none !important;
}
.common-button {
  width: 270px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  background-color: #ffb425;
  border-radius: 4px;
  text-align: center;
  font-size: 20px;
  margin: 40px auto 50px;
  cursor: pointer;
}
.common-norecord {
  color: red;
  text-align: center;
  padding: 20px;
  background-color: #fff;
  border: 1px solid #f0f0f0;
}
body,
ul,
li,
dl,
dt,
dd,
img,
form {
  margin: 0px;
  padding: 0px;
  list-style-type: none;
  border: 0px;
}
body {
  font-size: 16px !important;
  /* font-family: "微软雅黑" !important; */
}

.clear:after {
  content: "";
  display: block;
  clear: both;
  font-size: 0px;
  height: 0px;
}
.clear2:after {
  content: "";
  display: block;
  clear: both;
  font-size: 0px;
  height: 10px;
}
.ellipsis li,
.ellipsis .title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.backtop {
  position: fixed;
  z-index: 9999;
  right: 10px;
  bottom: 10px;
  opacity: 1;
  transition: all 1s;
}
.backtop.hide-bt {
  opacity: 0;
}
.backtop .dl {
  margin-top: 5px;
  position: relative;
}
.backtop .dl .dt {
  width: 40px;
  height: 40px;
  border-radius: 40px;
  background-color: #f5f5f5;
  background-size: auto 25px;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid #f0f0f0;
  cursor: pointer;
}
.backtop .dl.wechat .dt {
  background-image: url(/static/img/backtop-ico.svg);
}
.backtop .dl.service .dt {
  background-image: url(/static/img/backtop-ico2.svg);
}
.backtop .dl.bt .dt {
  border: 1px solid #1b57af;
  background-image: url(/static/img/backtop-ico3.svg);
  background-color: #1b57af;
}
.backtop .dl .dd {
  position: absolute;
  right: 60px;
  bottom: 0;
  display: none;
}
.backtop .dl:hover .dd {
  display: block;
}
.backtop .dl.wechat .dd .wechat-qr {
  width: 150px;
  height: 150px;
  background-image: url(/static/img/backtop-wechat-qr.png);
  background-size: auto 120px;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  box-shadow: 0 0 10px 0 #ccc;
}

.table {
  border-spacing: 1px;
  border-collapse: separate;
  background-color: #ccc;
  width: 100%;
}
.table td {
  background-color: #fff;
}
select {
  font-family: Microsoft YaHei !important;
}
select option {
  font-family: Microsoft YaHei !important;
}

.wfoot {
  background-color: #1b57af;
  padding: 5px 0;
  text-align: center;
  color: #fff;
  font-size: 14px;
}
.wfoot .li {
  margin: 5px 0;
}
.wfoot a {
  color: #fff;
}
.wfoot .li .fqr {
  margin-top: 20px;
  font-size: 16px;
}
.wfoot .li .fqr .dl {
  margin: 0 5px;
}
.wfoot .li .fqr .dl .dt {
  border-radius: 5px;
  overflow: hidden;
  height: 92px;
}

@media (max-width: 640px) {
  .footer ul li:nth-child(1),
  .footer ul li:nth-child(3),
  .footer ul li:nth-child(4) {
    display: none;
  }
}
.qrcode {
  display: inline-block;
}
.qrcode canvas img {
  width: 132px;
  height: 132px;
  background-color: #fff;
  padding: 6px;
  box-sizing: border-box;
}
.weixin-tip {
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  filter: alpha(opacity=80);
  height: 100%;
  width: 100%;
  z-index: 100;
}
.weixin-tip p {
  text-align: center;
  margin-top: 10%;
  padding: 0 5%;
}
</style>
